exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-push {\n  position: absolute;\n  top: 49vh;\n  left: -26px;\n}\n.button-push:hover,\n.button-pop-up:hover {\n  cursor: pointer;\n}\n.image-button {\n  color: black;\n  font-size: 24px;\n}\n", ""]);

// exports
